import { Card } from '@components/base/layout';
import { Text } from '@components/base/display';
import { CallErpEndpointConfigPanel } from './CallErpEndpointConfigPanel';
import { ErpLoginConfigPanel } from './ErpLoginConfigPanel';
import { CollectUserInputConfigPanel } from './CollectUserInputConfigPanel';
import { SendEmailConfigPanel } from './SendEmailConfigPanel';
import { GenerateReportConfigPanel } from './GenerateReportConfigPanel';
import { CallAiAgentConfigPanel } from './CallAiAgentConfigPanel';
import { FailWorkflowConfigPanel } from './FailWorkflowConfigPanel';

interface StepConfigPanelProps {
  readonly stepType: string;
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

function ConfigContent({ stepType, getValue, setValue }: Readonly<StepConfigPanelProps>) {
  switch (stepType) {
    case 'call-erp-endpoint':
      return <CallErpEndpointConfigPanel getValue={getValue} setValue={setValue} />;
    case 'erp-login':
      return <ErpLoginConfigPanel getValue={getValue} setValue={setValue} />;
    case 'collect-user-input':
      return <CollectUserInputConfigPanel getValue={getValue} setValue={setValue} />;
    case 'send-email':
      return <SendEmailConfigPanel getValue={getValue} setValue={setValue} />;
    case 'generate-report':
      return <GenerateReportConfigPanel getValue={getValue} setValue={setValue} />;
    case 'call-ai-agent':
      return <CallAiAgentConfigPanel getValue={getValue} setValue={setValue} />;
    case 'fail-workflow':
      return <FailWorkflowConfigPanel getValue={getValue} setValue={setValue} />;
    default:
      return <Text color="muted">Select a step type to configure its settings.</Text>;
  }
}

export function StepConfigPanel({ stepType, getValue, setValue }: Readonly<StepConfigPanelProps>) {
  return (
    <Card>
      <Card.Header title="Step Configuration" />
      <Card.Content>
        <ConfigContent stepType={stepType} getValue={getValue} setValue={setValue} />
      </Card.Content>
    </Card>
  );
}
